/**
 * @file 隊が「休隊（未登録）」になったら継続起算日を disabled にする
 *
 */
'use strict'

/**
 * @classname ChangeDenActivityStatus
 * @classdesc 隊が「休隊（未登録）」になったら継続起算日を disabled にする
 */
export default class ChangeDenActivityStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.den_activity_status')
	 */
	constructor($e) {
		console.log('ChangeDenActivityStatus.constructor')
		this._$e = $e
		this._$denContinuationStartSateInput = this._$e.closest('.row').find('.den_continuation_start_date')
		this._$e.on('change', () => this.onChange())
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeDenActivityStatus
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeDenActivityStatus.onChange')
		this._$denContinuationStartSateInput.attr('disabled', this._$e.find('option:selected').data('status') == 'inactive')
	}
}
